import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IPaymentLinkGenerateResult {
  code: string;
  paymentMethodSetupLink: string;
  status: string;
  expiresAt: string;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentLinksService {
  private apiUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = baseUrl;
  }

  generate(accessKey: string): Observable<IPaymentLinkGenerateResult> {
    return this.http.post<IPaymentLinkGenerateResult>(
      this.apiUrl + 'v1/payment-links/generate',
      { accessKey: accessKey }
    );
  }
}
